<template>
  <div>
    
    <!-- Header -->
    <div class="header">
      
      <div class="header-left">
        <div class="header-backdrop">
          <div class="arrows-slider">
            <button class="swiperPrev" slot="button-prev" @click="prev()">
              <span class="icon-arrow-left"></span>
            </button>
            <button class="swiperNext" slot="button-next" @click="next()">
              <span class="icon-arrow-right"></span>
            </button>
          </div>

          <swiper class="swiper-home" ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="(row, index) in rows" :key="index" :data-swiper-autoplay="row.duration + '000'">
                <div class="slide-view" :style="{backgroundImage: 'url(' + row.file + ')'}">
                  <div class="container">
                    <div class="header-widget">
                      <span :style="{backgroundColor: row.lineColor}" class="wtts"></span>
                      <div class="bg-title mb-1"
                          v-html="row.title"
                          :style="'color:'+row.title_color+' !important'">
                      </div>
                      <router-link :to="row.redirect"
                        class="btn-line">{{ row.button }}
                      </router-link>
                    </div>
                  </div>
                </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>

      <div class="header-right">
        <div class="header-backdrop" 
          :style="'background-image:url('+row.image2+'); border-right: 3px solid #fff;'">
          <div class="title white-color"
              :style="'color:'+row.color2+' !important'">
              {{row.title2}}
            <span class="overlay-title"></span>
            <br />
            <router-link v-if="row.button2" :to="row.redirect2"
                class="btn-line btn-line-white">{{ row.button2 }}
            </router-link>
          </div>
          <span class="gradient-easing"></span>
        </div>
        <div class="header-backdrop" 
            :style="'background-image:url('+row.image3+');'">
          <div class="title white-color" 
              :style="'color:'+row.color3+' !important'">
              {{row.title3}}
            <span class="overlay-title"></span>
            <br />
            <router-link v-if="row.button3" :to="row.redirect3"
                class="btn-line btn-line-white">{{ row.button3 }}
            </router-link>
          </div>
          <span class="gradient-easing"></span>
        </div>

        <div class="header-backdrop d-flex align-items-center" 
            :style="'background-color: '+row.bgColor4+'; border-top: 3px solid #fff;'">
          <div>
            <div class="bg-title mb-3 white-color"
              v-html="row.title4"
              :style="'color:'+row.color4+' !important'">
            </div>
            <div class="text white-color mb-2"
              v-html="row.content4"
              :style="'color:'+row.contentColor4+' !important'">
            </div>
            <router-link v-if="row.button4" :to="row.redirect4"
              class="btn-line btn-line-white">{{ row.button4 }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- Header -->

  </div>
</template>

<style scoped>
.swiper-home {
  height: 100%;
}
.slide-view {
  height: 100%;
  background-size: cover;
}
.header-backdrop {
  position: relative;
}
.arrows-slider {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 15px;
}
.arrows-slider button {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 30px;
}
.arrows-slider button:active {
  opacity: 0.6;
}
.arrows-slider span {
  font-weight: bold;
  font-size: 30px;
  color: #fff;
}
h1 {
  margin: 0;
}
</style>

<script>
import axios from 'axios';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: "Section1",
  props: ['row'],
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      pgLoading: true,
      rows: [],
      swiperOptions: {
        loop: false,
        autoplay: {
          // delay: 4000, or data-swiper-autoplay="2000" in html
        },
        speed: 500,
        spaceBetween: 30,
        slidesPerView: 1,
        // navigation: {
        //     nextEl: '.swiperNext',
        //     prevEl: '.swiperPrev'
        // },
      }
    };
  },
  created() {
      this.fetchSlider();
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  methods: {
    prev() {
			this.$refs.mySwiper.$swiper.slidePrev();
		},
		next() {
			this.$refs.mySwiper.$swiper.slideNext();
    },
    fetchSlider() {
      axios
        .get(window.baseURL + "/sliders")
        .then((res) => {
          this.pgLoading = false;
          const data = res.data.rows;
          this.rows = data;
          console.log(data);
        })
        .catch(() => {});
    },
  },
};
</script>
